import { useSelector } from 'react-redux'

import type { ListOrgRecordingsApiArg } from '@/__generated/es-api'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'

export const useGetCallRecordings = (query: Omit<ListOrgRecordingsApiArg, 'orgId'>) => {
  const orgId = useSelector(selectOrgId)
  return esApi.endpoints.listOrgRecordings.useQuery({ orgId: orgId.toString(), ...query }, { skip: !orgId })
}
